import isUndefined from 'lodash/isUndefined';
import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import isPlainObject from 'lodash/isPlainObject';
import URLSearchParams from '@ungap/url-search-params';

export default function paramsBuilder(params = {}) {
  if (isEmpty(params) || !isPlainObject(params)) {
    return '';
  }
  const searchParams = new URLSearchParams();
  forEach(params, (value, key) =>
    isUndefined(value) ? null : searchParams.append(key, value),
  );
  return `?${searchParams}`;
}
